module.exports = __webpack_public_path__ + "img/change-password.caa3e840.gif";